export default __webpack_public_path__ + "static/media/whiteBullet.8fb0bf7f.svg";